var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCreditCard1Alternate = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M21 3.5H3a3 3 0 0 0-3 3v11a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3v-11a3 3 0 0 0-3-3Zm-18 2h18a1 1 0 0 1 1 1v1a.5.5 0 0 1-.5.5h-19a.5.5 0 0 1-.5-.5v-1a1 1 0 0 1 1-1Zm18 13H3a1 1 0 0 1-1-1v-6a.5.5 0 0 1 .5-.5h19a.5.5 0 0 1 .5.5v6a1 1 0 0 1-1 1Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 14.5H5a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2Z"
})));
export { SvgCreditCard1Alternate as ReactComponent };
export default __webpack_public_path__ + "22349cde7c3c47f5174f92de89a673c3989d592ca2d047c054176d438a293e7e.svg";